import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { RegressionScenario } from "./regression.types";

interface Props {
  scenarios: RegressionScenario[];
  topN?: number;
}

export const RegressionSlowestScenarios: React.FC<Props> = ({ scenarios, topN = 8 }) => {
  const slowest = useMemo(
    () => [...scenarios].sort((a, b) => b.durationMs - a.durationMs).slice(0, topN),
    [scenarios, topN],
  );

  if (slowest.length === 0) {
    return <Typography variant="body2" color="text.secondary">No scenario data in the latest run.</Typography>;
  }

  const maxMs = slowest[0].durationMs || 1;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.125 }}>
      {slowest.map((s) => (
        <Box key={s.scenarioId} sx={{ display: "flex", alignItems: "center", gap: 1.375 }}>
          <Typography variant="body2" color="text.secondary" sx={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {s.name}
          </Typography>
          <Box sx={{ width: 180, height: 6, bgcolor: "action.hover", borderRadius: "3px", overflow: "hidden", flex: "none" }}>
            <Box sx={{ height: "100%", bgcolor: "primary.main", borderRadius: "3px", width: `${(s.durationMs / maxMs) * 100}%` }} />
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ width: 52, textAlign: "right", flex: "none" }}>
            {(s.durationMs / 1000).toFixed(1)}s
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default RegressionSlowestScenarios;
